import {
  SellerOfferPriceSuggestionModel,
  OfferPriceSuggestionOption,
  ConversationMessageEntity,
  OfferMessage,
} from '@marketplace-web/domain/conversation-messaging-data'

export const getPreselectedOfferPriceSuggestionOption = (
  abTestVariant: string,
  offerSuggestions: Array<SellerOfferPriceSuggestionModel>,
): OfferPriceSuggestionOption => {
  switch (abTestVariant) {
    case 'a':
      return {
        isCustom: false,
        suggestion: offerSuggestions[0],
      }
    case 'b':
      return {
        isCustom: true,
      }
    default:
      return {
        isCustom: true,
      }
  }
}

export function isOfferMessage(message: ConversationMessageEntity): message is OfferMessage {
  if (!message) return false

  return 'isCurrentOffer' in message
}
